import api from '../../../services/api';

const API_URL = '/api/v1/admin/GlobalSetup';

/** @returns {Promise<ApiAdmin.GetGlobalSetupResponse>} */
export const getGlobalSetup = () => api.get(API_URL);

/**
 * @param {GlobalSetup.GlobalSetup} data
 * @returns {Promise<GlobalSetup.EditGlobalSetupSettingsResponse>}
 */
export const updateGlobalSetupSettings = (data) => api.put(`${API_URL}/UpdateGlobalSetupSettings`, data);
